export const getMaskedString = (str = ''): string => {
  if (!str) return ''

  // use Array.from to handle multi-byte characters
  const chars = Array.from(str)

  if (chars.length <= 2) {
    return '*'.repeat(chars.length)
  }

  const maskLength = chars.length - 2
  return chars[0] + '*'.repeat(maskLength) + chars[chars.length - 1]
}

export const isNumeric = (n: string | number): boolean => {
  return !isNaN(parseFloat(n + '')) && isFinite(+n)
}

export const capitalizeString = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

export const escapeNewlineandTab = (text: string) =>
  text.replace(/\n/gm, '\\n').replace(/\t/gm, '\\t')

export const stringEscape = (val: string) => {
  if (typeof val != 'string') return val
  return val
    .replace(/[\\]/gm, '\\\\')
    .replace(/[\b]/gm, '\\b')
    .replace(/[\f]/gm, '\\f')
    .replace(/[\n]/gm, '\\n')
    .replace(/[\r]/gm, '\\r')
    .replace(/[\t]/gm, '\\t')
    .replace(/\\'/gm, "\\'")
    .replace(/"/gm, '\\"')
}

export const escapeHtml = (unsafe) => {
  return unsafe.replace(/[&<>"'\\/]/g, function (match) {
    switch (match) {
      case '&':
        return '&amp;'
      case '<':
        return '&lt;'
      case '>':
        return '&gt;'
      case '"':
        return '&quot;'
      case "'":
        return '&#39;'
      case '/':
        return '&#x2F;'
      /**TODO: Temporary Hack for handling back slash in  email template footer. LA-8053*/
      case '\\':
        return ''
      default:
        return match
    }
  })
}
export const unescapeHtml = (text) => {
  const tempElement = document.createElement('textarea')
  tempElement.innerHTML = text
  return tempElement.value
}

export function upperSnakeCasetoTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function camelCaseToUpperSnakeCase(str: string): string {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // Insert underscore before uppercase letters
    .toUpperCase() // Convert to uppercase
}

export function getInitials(name: string): string {
  // Split the name into words based on spaces
  const words: string[] = name.split(' ')

  // Initialize an empty string to store initials
  let initials = ''

  // Iterate through the words and extract the first character of each word
  words.forEach((word) => {
    if (word.length > 0) {
      initials += word[0].toUpperCase() // Append the uppercase first character
    }
  })

  return initials.length >= 2 ? initials.slice(0, 2) : name.slice(0, 2)
}

/**
 * Removes spaces before and after forward slashes in a string
 * @param str - The input string that may contain spaces around forward slashes
 * @returns The string with spaces around forward slashes removed
 * @example
 * removeSpacesAroundSlashes("All Files / test_data / Automation files")
 * // Returns: "All Files/test_data/Automation files"
 */
export function removeSpacesAroundSlashes(str: string): string {
  if (!str) return str

  return str.replace(/\s*\/\s*/g, '/')
}

export function truncateString(str: string, maxLength: number): string {
  if (!str || str.length <= maxLength) return str
  return str.slice(0, maxLength) + '...'
}
